import { render, staticRenderFns } from "./ForeplayMetricsSection.vue?vue&type=template&id=4f4928c0&scoped=true"
import script from "./ForeplayMetricsSection.vue?vue&type=script&lang=js"
export * from "./ForeplayMetricsSection.vue?vue&type=script&lang=js"
import style0 from "./ForeplayMetricsSection.vue?vue&type=style&index=0&id=4f4928c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4928c0",
  null
  
)

export default component.exports